export default __webpack_public_path__ + "static/media/department.a30a2132.png";